import SideBarLeftPanel from './SideBarLeftPanel.component';

export default SideBarLeftPanel;